import React from 'react'
import { useEffect, useState } from 'react'
import { IoIosArrowUp } from 'react-icons/io'

const BottomtoTop = () => {
    const [isVisible, setIsVisible] = useState(false)
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true)
        } else {
            setIsVisible(false)
        }
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility)

        return () => {
            window.removeEventListener('scroll', toggleVisibility)
        }
    }, [])
    return (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-4 right-4 z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'
                } bg-basecolor text-white hover:bg-white hover:text-gray-800 border border-gray-300 rounded-full p-2 shadow-md`}
            aria-label="Scroll to top"
        >
            <IoIosArrowUp size={20} />
        </button>
    )
}

export default BottomtoTop